import React, { useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

import { useTranslation } from "react-i18next";
import Header from "../../../layouts/header";
import images from "../../../constant/images";
import { useSelector } from "react-redux";
import axios from "axios";

export default function Gallery() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [gallery, setGallery] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null); // Added state for errors

  const navigationRefs = useRef({});

  const fetchGallery = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/events`);
      const data = response.data.events.filter((event) => event.galleries.length > 0)?.map((gallery) => ({
        gallery: gallery.galleries,
        title: gallery.title,
      }));
      setGallery(data);

    } catch (error) {
      console.error("Failed to fetch gallery:", error);
      setError("Failed to load gallery data. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchGallery();
  }, [fetchGallery]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState("");

  if (!isLoading) {

    
  }
  

  return (
    <div className="flex flex-col">
      <Header image={images.about} title="Gallery" />

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="w-9 h-9 border-4 border-black border-l-transparent rounded-full animate-spin"></div>
        </div>
      ) : gallery?.length > 0 ? (
        <div>
          {gallery?.map((item, index) => {
            if (item.gallery?.length > 0) {
              if (!navigationRefs.current[item.title]) {
                navigationRefs.current[item.title] = {
                  prevRef: React.createRef(),
                  nextRef: React.createRef(),
                };
              }
              const { prevRef, nextRef } = navigationRefs.current[item.title];

              return (
                <div key={index}>
                  <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-6 sm:mt-8 md:mt-10 text-center mb-4 sm:mb-6 md:mb-8 part custom-font">
                    {item.title}
                  </h1>

                  <div className="bg-gray-100 py-6 sm:py-8 md:py-10 lg:py-12 px-4 sm:px-6 md:px-8 lg:px-[10rem] mb-8 sm:mb-10 md:mb-12">
                    <div className="relative">
                      {item.gallery.length >= 4 && (
                        <>
                          <button
                            ref={nextRef}
                            className="absolute top-1/2 left-0 sm:left-[-15px] md:left-[-20px] lg:left-[-30px] transform -translate-y-1/2 z-10 text-lg sm:text-xl md:text-2xl rounded-full text-black p-2 sm:p-3 md:p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all"
                          >
                            <FaAngleLeft />
                          </button>

                          <button
                            ref={prevRef}
                            className="absolute top-1/2 right-0 sm:right-[-15px] md:right-[-20px] lg:right-[-30px] transform -translate-y-1/2 z-10 text-lg sm:text-xl md:text-2xl rounded-full text-black p-2 sm:p-3 md:p-4 bg-white shadow-md hover:bg-[#119f04] hover:text-white transition-all"
                          >
                            <FaAngleRight />
                          </button>
                        </>
                      )}

                      <Swiper
                        spaceBetween={25}
                        loop={true}
                        breakpoints={{
                          0: { slidesPerView: 1 },
                          640: { slidesPerView: 2, spaceBetween: 20 },
                          768: { slidesPerView: 3, spaceBetween: 25 },
                          1024: { slidesPerView: 3, spaceBetween: 30 },
                        }}
                        navigation={{
                          prevEl: prevRef.current,
                          nextEl: nextRef.current,
                        }}
                        modules={[Navigation, Pagination, Autoplay]}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        onSwiper={(swiper) => {
                          setTimeout(() => {
                            const { prevRef, nextRef } =
                              navigationRefs.current[item.title];

                            if (
                              swiper.params?.navigation &&
                              prevRef.current &&
                              nextRef.current
                            ) {
                              swiper.params.navigation.prevEl = prevRef.current;
                              swiper.params.navigation.nextEl = nextRef.current;

                              if (swiper.navigation?.init) {
                                swiper.navigation.init();
                                swiper.navigation.update();
                              }
                            }
                          }, 0);
                        }}
                        className="w-full "
                      >
                        {item.gallery?.map((image, i) => (
                          <SwiperSlide key={i}>
                            <div className="relative group flex justify-center items-center p-1 sm:p-2 h-[150px] sm:h-[180px] md:h-[220px] lg:h-[260px] w-full mx-auto">
                              <div
                                className="relative overflow-hidden w-full h-full rounded-xl shadow-lg"
                                onClick={() => {
                                  setImage(image.pic);
                                  setIsModalOpen(true);
                                }}
                              >
                                <img
                                  src={image.pic}
                                  alt="Event image"
                                  className="w-full h-full  transition-transform duration-500 group-hover:scale-110"
                                  style={{
                                    objectFit: "cover",
                                    objectPosition: "top",
                                  }}
                                />

                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                              </div>

                              <div className="absolute -bottom-4 left-0 right-0 h-4 bg-gradient-to-t from-gray-100 to-transparent opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                </div>
              );
            }
            // else{
            //   return(
            //     <div className="flex justify-center items-center h-full">
            //       <h3 className="text-xl font-semibold text-gray-400">
            //           No media yet
            //       </h3>
            //     </div>
            //   );
            // }
            
          })}
        </div>
      ) : (
        <div className="flex justify-center items-center h-full">
                  <h3 className="text-xl font-semibold text-gray-400">
                      No media yet
                    </h3>
                </div>
      )}

      {isModalOpen && (
        <div className="modal fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="modal-video relative lg:max-w-[80vw] lg:h-[80vh] bg-white">
            <button
              className="modal-close absolute -top-12 right-0 text-white text-3xl"
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>
            <img className="w-full h-full" src={image} />
          </div>
        </div>
      )}
    </div>
  );
}
